import { render, staticRenderFns } from "./EditGracePeriod.vue?vue&type=template&id=2e124bbd&scoped=true"
import script from "./EditGracePeriod.vue?vue&type=script&lang=js"
export * from "./EditGracePeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e124bbd",
  null
  
)

export default component.exports